import { useTranslation } from 'react-i18next';

import { Button } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import { CHIP_COLOR_RED, WHITE } from '~/Constants/Colors.constants';
import { FONT_SIZE_SMALL } from '~/Constants/UI.constants';
import React from 'react';
import { AlertTriangle } from '~/Components/Icons';

const useStyles = makeStyles(
  () => ({
    missingInfo: {
      padding: 5,
      background: CHIP_COLOR_RED,
      color: WHITE,
      fontSize: FONT_SIZE_SMALL,
      minWidth: 'auto',
      height: 'auto',

      '&:hover': {
        background: CHIP_COLOR_RED,
      },

      '> svg': {
        marginRight: 5,
        width: 16,
        height: 14,
      },
    },
    content: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  }),
  { name: 'orgMerchantListTable' },
);

export const MissingInfoButton = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Button className={classes.missingInfo} size={'medium'} variant="contained">
      <AlertTriangle />
      <span className={classes.content}>{t('organisation.merchant.status.missingInfo')}</span>
    </Button>
  );
};
